import React from 'react';
import './ModeSelection.css';
import './shared.css';
import { useTranslation } from 'react-i18next';
import Footer from './Footer';

function ModeSelection({ onSelectMode }) {
  const { t } = useTranslation();

  return (
    <div className="dashboard-container mode-selection-container">
      <div className="dashboard-header">
        <div className="header-branding">
          <img src="/yyslogo192.png" alt="YY Solutions" className="yys-logo" />
          <div>
            <h1>CALMU GALLERY</h1>
          </div>
        </div>
        <div className="header-actions">
          <button
            onClick={() => {
              window.location.href = 'https://www.calmu.design/gallery';
            }}
            className="logout-btn"
            title={t('dashboard.close') || '閉じる'}
          >
            {t('dashboard.close') || '閉じる'}
          </button>
        </div>
      </div>

      <div className="mode-selection-content">
        <h2>{t('modeSelection.title') || '利用方法を選択してください'}</h2>
        
        <div className="mode-cards">
          <div className="mode-card" onClick={() => onSelectMode('browser')}>
            <div className="mode-icon">🖥️</div>
            <h3>{t('modeSelection.browserMode') || 'ブラウザーで見る'}</h3>
            <p>{t('modeSelection.browserDescription') || 'サブスクリプションを選択してスライドショーを表示します'}</p>
          </div>

          <div className="mode-card" onClick={() => onSelectMode('device')}>
            <div className="mode-icon">
              {/* A landscape e-paper frame showing a picture (no emoji fits an e-ink display) */}
              <svg className="eink-icon" viewBox="0 0 64 46" aria-hidden="true">
                <rect x="1" y="1" width="62" height="44" rx="4" fill="#2f2f2f" />
                <rect x="6" y="6" width="52" height="34" rx="1" fill="#ebe8e1" />
                <circle cx="44" cy="15" r="4" fill="#9a978f" />
                <path d="M6 40 L22 21 L31 31 L38 24 L58 40 Z" fill="#6f6c66" />
                <path d="M6 40 L16 33 L24 38 L30 35 L36 40 Z" fill="#4a4844" />
              </svg>
            </div>
            <h3>{t('modeSelection.deviceMode') || 'デバイスへの配信を設定'}</h3>
            <p>{t('modeSelection.deviceDescription') || 'デバイスを選択してスケジュールを設定します'}</p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ModeSelection;
